"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendDynatraceEvent = void 0;
var sendDynatraceEvent = function (name, attributes) {
    var dtrum = window.dtrum;
    if (!dtrum)
        return null;
    var actionId = dtrum.enterAction(name);
    if (attributes) {
        var keys = Object.keys(attributes);
        var formattedAttributes_1 = {};
        keys.forEach(function (v) {
            formattedAttributes_1[v] = { value: attributes[v], public: true };
        });
        dtrum.addActionProperties(actionId, undefined, undefined, formattedAttributes_1);
    }
    dtrum.leaveAction(actionId);
    return actionId;
};
exports.sendDynatraceEvent = sendDynatraceEvent;
//# sourceMappingURL=sendDynatraceEvent.js.map